/**
 * Get the current event
 * @param {object} state - The vuex state object
 * @return {object} current event
 */
export const getCurrentEvent = (state) => {
  return state.currentEvent
};
